import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "encore_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice: value, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] rounded-xl shadow-2xl p-4 flex flex-col sm:flex-row sm:items-center gap-3"
      style={{ background: "var(--ink, #111827)", border: "1px solid rgba(255,255,255,0.12)" }}
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-2.5 flex-1">
        <Cookie size={18} strokeWidth={1.5} className="mt-0.5 shrink-0" style={{ color: "rgba(255,255,255,0.7)" }} />
        <p className="text-xs leading-relaxed" style={{ color: "rgba(255,255,255,0.75)" }}>
          We use cookies to improve your experience and analyze site traffic. See our{" "}
          <Link to="/cookies" className="underline text-white hover:opacity-80" data-testid="cookie-banner-policy-link">
            Cookie Policy
          </Link>.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          onClick={() => choose("declined")}
          className="px-3 py-1.5 text-xs rounded-lg transition-colors hover:text-white"
          style={{ color: "rgba(255,255,255,0.6)", border: "1px solid rgba(255,255,255,0.2)" }}
          data-testid="cookie-banner-decline-btn"
        >
          Decline
        </button>
        <button
          onClick={() => choose("accepted")}
          className="px-3.5 py-1.5 text-xs font-medium rounded-lg bg-white text-gray-900 transition-opacity hover:opacity-85"
          data-testid="cookie-banner-accept-btn"
        >
          Accept
        </button>
      </div>
    </div>
  );
}
